'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = Graticule;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _group = require('@vx/group');

var _additionalProps = require('../util/additionalProps');

var _additionalProps2 = _interopRequireDefault(_additionalProps);

var _d3Geo = require('d3-geo');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function Graticule(_ref) {
  var graticule = _ref.graticule,
      lines = _ref.lines,
      outline = _ref.outline,
      extent = _ref.extent,
      extentMajor = _ref.extentMajor,
      extentMinor = _ref.extentMinor,
      step = _ref.step,
      stepMajor = _ref.stepMajor,
      stepMinor = _ref.stepMinor,
      precision = _ref.precision,
      restProps = _objectWithoutProperties(_ref, ['graticule', 'lines', 'outline', 'extent', 'extentMajor', 'extentMinor', 'step', 'stepMajor', 'stepMinor', 'precision']);

  var currGraticule = (0, _d3Geo.geoGraticule)();
  if (extent) currGraticule.extent(extent);
  if (extentMajor) currGraticule.extentMajor(extentMajor);
  if (extentMinor) currGraticule.extentMinor(extentMinor);
  if (step) currGraticule.step(step);
  if (stepMajor) currGraticule.stepMajor(stepMajor);
  if (stepMinor) currGraticule.stepMinor(stepMinor);
  if (precision) currGraticule.stepMinor(precision);
  return _react2.default.createElement(_group.Group, {
    className: 'vx-geo-graticule'
  }, graticule && _react2.default.createElement('path', _extends({
    d: graticule(currGraticule()),
    fill: 'none',
    stroke: 'black'
  }, restProps)), lines && currGraticule.lines().map(function (line, i) {
    return _react2.default.createElement('g', {
      key: i
    }, _react2.default.createElement('path', _extends({
      d: lines(line),
      fill: 'none',
      stroke: 'black'
    }, (0, _additionalProps2.default)(restProps, _extends({}, line, {
      index: i
    })))));
  }), outline && _react2.default.createElement('path', _extends({
    d: outline(currGraticule.outline()),
    fill: 'none',
    stroke: 'black'
  }, restProps)));
}

Graticule.propTypes = {
  graticule: _propTypes2.default.func,
  lines: _propTypes2.default.func,
  outline: _propTypes2.default.func
};